document.addEventListener("DOMContentLoaded", () => {
  const navList = document.querySelector(".ingredients-nav__list");
  const groups = document.querySelectorAll(".ingredients-group");

  // Collect existing letters
  const existingLetters = new Set(
    Array.from(groups).map((group) => group.dataset.letter?.toUpperCase())
  );

  // Build A–Z nav letters
  for (let i = 65; i <= 90; i++) {
    const letter = String.fromCharCode(i);
    const link = document.createElement("a");
    link.textContent = letter;
    link.className = "ingredients-nav__letter body-m";

    if (existingLetters.has(letter)) {
      link.href = `#ingredient-${letter.toLowerCase()}`;
      link.addEventListener("click", (e) => {
        e.preventDefault();

        // Remove active modifier
        document
          .querySelectorAll(".ingredients-nav__letter--active")
          .forEach((el) =>
            el.classList.remove("ingredients-nav__letter--active")
          );

        // Add active modifier
        link.classList.add("ingredients-nav__letter--active");

        // Scroll to section
        const targetEl = document.getElementById(
          `ingredient-${letter.toLowerCase()}`
        );
        if (targetEl) {
          window.scrollTo({
            top: targetEl.offsetTop - 20,
            behavior: "smooth",
          });
        }
      });
    } else {
      link.classList.add("ingredients-nav__letter--disabled");
      link.setAttribute("aria-disabled", "true");
      link.tabIndex = -1;
    }

    navList.appendChild(link);
  }

  // --- Automatic active letter on scroll ---
  const navLetters = document.querySelectorAll(".ingredients-nav__letter");

  const updateActiveLetter = () => {
    let currentLetter = null;

    groups.forEach((group) => {
      const rect = group.getBoundingClientRect();
      if (rect.top <= 100) {
        // adjust threshold as needed
        currentLetter = group.dataset.letter?.toUpperCase();
      }
    });

    navLetters.forEach((letterEl) => {
      if (letterEl.textContent === currentLetter) {
        letterEl.classList.add("ingredients-nav__letter--active");
      } else {
        letterEl.classList.remove("ingredients-nav__letter--active");
      }
    });
  };

  window.addEventListener("scroll", updateActiveLetter);
  updateActiveLetter(); // initial check
});
